import { render, staticRenderFns } from "./create_enity.vue?vue&type=template&id=be89e676&scoped=true&"
import script from "./create_enity.vue?vue&type=script&lang=js&"
export * from "./create_enity.vue?vue&type=script&lang=js&"
import style0 from "./create_enity.vue?vue&type=style&index=0&id=be89e676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be89e676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be89e676')) {
      api.createRecord('be89e676', component.options)
    } else {
      api.reload('be89e676', component.options)
    }
    module.hot.accept("./create_enity.vue?vue&type=template&id=be89e676&scoped=true&", function () {
      api.rerender('be89e676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/plombs/create_enity.vue"
export default component.exports